import { Box, Button } from "@mui/material";
import QrCodeTab from "./QrCodeTab";
import AllTransaction from "./AllTransaction";
import Sip from "./Sip";
import Client from "./Client";
import Mfd from "./Mfd";
import Employee from "./Employee";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Proposal from "./Proposal";
import { useSelector } from "react-redux";

export default function DashboardTabs({ id }) {
  const [activeTab, setActiveTab] = useState(null);
  const roleResponse = useSelector((state) => state?.login?.login?.role);

  const style = {
    flex: 1,
    height: { xs: 40, sm: 60, md: 35 },
    maxWidth: { xs: "100%", md: 150 },
    fontSize: { xs: "10px", sm: "13px", md: "14px" },
    padding: { xs: "5px 4px", md: "8px 8px" },
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "center",
    alignItems: "center",
    lineHeight: 1.2,
  };
  const [searchParams] = useSearchParams();
  const partnerUsername = searchParams.get("partnerUsername");
  useEffect(() => {
    if (roleResponse?.PartnerQR?.read === 1) {
      setActiveTab("QrCode");
    } else if (roleResponse?.PartnerAllTransactions?.read === 1) {
      setActiveTab("AllTransaction");
    } else if (roleResponse?.PartnerSip?.read === 1) {
      setActiveTab("Sip");
    } else if (roleResponse?.PartnerClient?.read === 1) {
      setActiveTab("Client");
    } else if (roleResponse?.PartnerSubPartner?.read === 1) {
      setActiveTab("Mfd");
    } else if (roleResponse?.PartnerEmployee?.read === 1) {
      setActiveTab("Employee");
    } else if (roleResponse?.PartnerProposal?.read === 1) {
      setActiveTab("Proposal");
    }
  }, [roleResponse]);
  return (
    <Box>
      {/* -------- MAIN TABS -------- */}
      <Box
        display="flex"
        justifyContent="center"
        flexWrap="wrap"
        gap={2}
        mb={2}
      >
        {roleResponse?.PartnerQR?.read === 1 && (
          <Button
            variant={activeTab === "QrCode" ? "contained" : "outlined"}
            onClick={() => setActiveTab("QrCode")}
            sx={style}
          >
            QR Code
          </Button>
        )}
        {roleResponse?.PartnerAllTransactions?.read === 1 && (
          <Button
            variant={activeTab === "AllTransaction" ? "contained" : "outlined"}
            onClick={() => setActiveTab("AllTransaction")}
            sx={style}
          >
            All Trans
          </Button>
        )}
        {roleResponse?.PartnerSip?.read === 1 && (
          <Button
            variant={activeTab === "Sip" ? "contained" : "outlined"}
            onClick={() => setActiveTab("Sip")}
            sx={style}
          >
            SIP
          </Button>
        )}
        {roleResponse?.PartnerClient?.read === 1 && (
          <Button
            variant={activeTab === "Client" ? "contained" : "outlined"}
            onClick={() => setActiveTab("Client")}
            sx={style}
          >
            Client
          </Button>
        )}

        {roleResponse?.PartnerSubPartner?.read === 1 && (
          <Button
            variant={activeTab === "Mfd" ? "contained" : "outlined"}
            onClick={() => setActiveTab("Mfd")}
            sx={style}
          >
            Sub-Partner
          </Button>
        )}
        {roleResponse?.PartnerEmployee?.read === 1 && (
          <Button
            variant={activeTab === "Employee" ? "contained" : "outlined"}
            onClick={() => setActiveTab("Employee")}
            sx={style}
          >
            Employee
          </Button>
        )}
        {roleResponse?.PartnerProposal?.read === 1 && (
          <Button
            variant={activeTab === "Proposal" ? "contained" : "outlined"}
            onClick={() => setActiveTab("Proposal")}
            sx={style}
          >
            Proposal
          </Button>
        )}
      </Box>

      {/* -------- CONTENT -------- */}
      {activeTab === "QrCode" && (
        <QrCodeTab partnerUserID={id} partnerUsername={partnerUsername} />
      )}
      {activeTab === "AllTransaction" && <AllTransaction id={id} />}
      {activeTab === "Sip" && <Sip id={id} />}
      {activeTab === "Client" && (
        <Client partnerUserID={id} partnerUsername={partnerUsername} />
      )}
      {activeTab === "Mfd" && (
        <Mfd partnerUserID={id} partnerUsername={partnerUsername} />
      )}
      {activeTab === "Employee" && (
        <Employee partnerUserID={id} partnerUsername={partnerUsername} />
      )}
      {activeTab === "Proposal" && <Proposal id={id} />}
    </Box>
  );
}
